import { Component } from '@theme/component';

/**
 * Handles copying text to clipboard, from an event like a click.
 * Optionally reveals a success message and/or swaps copy/success icons.
 * @extends {Component}
 */
class CopyToClipboardComponent extends Component {
  /** @type {ReturnType<typeof setTimeout> | undefined} */
  #successTimeout;

  /**
   * @param {Event} [event]
   */
  copyToClipboard(event) {
    event?.preventDefault?.();

    const copyContent = this.getAttribute('text-to-copy');

    if (!copyContent) return;

    navigator.clipboard.writeText(copyContent);

    const copySuccessMessage = this.refs.copySuccessMessage;

    if (copySuccessMessage instanceof Element) {
      copySuccessMessage.classList.remove('visually-hidden');
    }

    this.#showSuccessIcons();
  }

  #showSuccessIcons() {
    const copyIcon = this.refs.copyIcon;
    const successIcon = this.refs.successIcon;

    if (!(copyIcon instanceof Element) || !(successIcon instanceof Element)) return;

    copyIcon.classList.add('visually-hidden');
    successIcon.classList.remove('visually-hidden');

    const duration = Number(this.getAttribute('success-duration'));

    if (!Number.isFinite(duration) || duration <= 0) return;

    clearTimeout(this.#successTimeout);
    this.#successTimeout = setTimeout(() => {
      successIcon.classList.add('visually-hidden');
      copyIcon.classList.remove('visually-hidden');
    }, duration);
  }
}

if (!customElements.get('copy-to-clipboard-component')) {
  customElements.define('copy-to-clipboard-component', CopyToClipboardComponent);
}
